import { useState } from "react";
import axiosInstance from "./apiClient";
import { AxiosRequestConfig } from "axios";

const useApiError = <T, B = any>(
  url: string,
  method: "GET" | "POST" | "PUT" | "DELETE" = "GET",
  responseType: "json" | "blob" = "json"
) => {
  const [data, setData] = useState<T | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [errorStatus, setErrorStatus] = useState<string | null>(null); // Added errorStatus
  const [loading, setLoading] = useState<boolean>(false);

  const fetchData = async (body?: B, config?: Omit<AxiosRequestConfig, 'method' | 'url' | 'data'>) => {
    setLoading(true);
    setError(null);
    setErrorStatus(null); // Reset error status
    try {
      const response = await axiosInstance({
        url,
        method,
        data: body,
        responseType,
        ...config,
      });

      setData(response.data as T);
      return response.data as T;
    } catch (err: any) {
      // Don't throw the error, handle it gracefully
      const errorMessage = err.response?.data?.message || err.message;
      const statusCode = err.response?.status;
      
      setError(errorMessage);
      setErrorStatus(`${statusCode}`);
      
      // Return error object instead of throwing
      return { 
        error: errorMessage, 
        status: statusCode,
        isError: true 
      } as any;
    } finally {
      setLoading(false);
    }
  };

  const resetData = () => {
    setData(null);
    setError(null);
    setErrorStatus(null);
  };

  return { data, error, errorStatus, loading, fetchData, resetData };
};

export default useApiError;